import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormGroup,
  CFormText,
  CInput,
  CInputFile,
  CInputGroup,
  CInputRadio,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
  CTextarea,
} from "@coreui/react";

//import { CFormCheck } from "@coreui/react";
import React from "react";
import { downloadUrl } from "src/_apiConfig/apiCall";
const CommonInput = (props) => {
  return (
    <>
      <CInput
        value={props.value}
        onChange={props.onChange}
        name={props.name}
        placeholder={props.placeholder}
        required={props.required}
        type={props.type}
      />
    </>
  );
};
export const CommonForm = (props) => {
  return (
    <>
      <CFormGroup row>
        <CCol md="3">
          <CLabel htmlFor="url-input">Name</CLabel>
        </CCol>
        <CCol xs="12" md="9">
          <CommonInput
            value={props.valueUser}
            onChange={props.onChangeUser}
            name="Name"
            type="text"
            placeholder="Enter USer Name"
            required
          />
        </CCol>
      </CFormGroup>

      <CFormGroup row>
        <CCol md="3">
          <CLabel htmlFor="template-input">Role</CLabel>
        </CCol>
        <CCol xs="12" md="9">
          <CSelect
            custom
            name="select"
            id="select"
            value={props.valueRole}
            onChange={props.onChangeRole}
          >
            <option value="Guest" defaultValue>
              Guest
            </option>
            <option value="Admin">Admin</option>
            <option value="Alien">Alien</option>
            <option value="Member">Member </option>
            <option value="Staff">Staff </option>
          </CSelect>
        </CCol>
      </CFormGroup>
      <CFormGroup row>
        <CCol md="3">
          <CLabel htmlFor="template-input">Status</CLabel>
        </CCol>
        <CCol xs="12" md="9">
          <CSelect
            custom
            name="select"
            id="select"
            value={props.valueStatus}
            onChange={props.onChangeStatus}
          >
            <option value="Panding">Panding</option>
            <option value="Inactive">Inactive</option>
            <option value="Banned">Banned</option>
            <option value="Active" defaultValue>
              Active
            </option>
            <option value="Don't panic!">Don't panic! </option>
          </CSelect>
        </CCol>
      </CFormGroup>
      <CButton type="submit" color="primary">
        {props.btnName}
      </CButton>
    </>
  );
};

export default CommonInput;

// Function to validate the input date
export const isValidDate = (dateString) => {
  console.log("isValidDate ddd", dateString);
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) return false;

  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

export const CommonPage = (props) => {
  return (
    <CCard>
      {props.listName !== "" && (
        <CCardHeader>
          <CRow className="mt-2">
            <CCol xl={12}>
              <h3>{props.listName}</h3>
            </CCol>
          </CRow>
        </CCardHeader>
      )}
      <CCardBody>
        {props.additional}
        {props.mainBody}
        {props.additionalAfter}
      </CCardBody>
    </CCard>
  );
};

export const DetailSectionBind = (props) => {
  return (
    <CRow>
      <CCol xs="12">
        {/* <CCard> */}
        {(props.header || props.title) && (
          <CCardHeader>
            {props.header && <h2> {props.header}</h2>}
            {props.title && <h4> {props.title}</h4>}
          </CCardHeader>
        )}
        {props.body && (
          <CCardBody>
            <CRow>{props.body}</CRow>
          </CCardBody>
        )}
        {/* </CCard> */}
      </CCol>
    </CRow>
  );
};

export const DetailRow = (props) => {
  return (
    <CRow hidden={props.hidden}>
      <CCol xs="12" className={props.className}>
        {/* <CCard> */}
        {props.header && (
          <>
            <h4> {props.header}</h4>
            <hr />
          </>
        )}
        {props.body && <CRow>{props.body}</CRow>}
        {/* </CCard> */}
      </CCol>
    </CRow>
  );
};

export const DetailRowOnly = (props) => {
  return (
    <CRow>
      <CCol className={props.className}>{props.body}</CCol>
    </CRow>
  );
};

export const DetailLableBind = (props) => {
  const CheckValue = props.value && props.value;
  return (
    <CCol xxl={3} xl={4} md={4} sm={6} xs={12} className={"mt-2"}>
      <CLabel htmlFor="exampleFormControlInput1">{props.lable} :</CLabel>
      <br />
      <CLabel htmlFor="exampleFormControlInput2">
        <b>{CheckValue}</b>
      </CLabel>
    </CCol>
  );
};

export const DetailLabelBind = (props) => {
  const CheckValue = props.value && props.value;
  const setClassName =
    props.className || "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12 mt-2";
  return (
    <CCol className={setClassName}>
      <CLabel htmlFor="exampleFormControlInput1">{props.lable} :</CLabel>
      <br />
      <CLabel htmlFor="exampleFormControlInput2">
        <b>{CheckValue}</b>
      </CLabel>
    </CCol>
  );
};

export const DetailLabel = (props) => {
  return (
    <CCol xxl={3} xl={4} md={4} sm={6} xs={12} className={"mt-2"}>
      <CLabel htmlFor="exampleFormControlInput1">{props.lable} :</CLabel>
    </CCol>
  );
};

export const DetailChecbox = (props) => {
  return (
    <CCol xxl={3} xl={4} md={4} sm={6} xs={12} className={"mt-1"}>
      <CFormGroup variant="custom-radio">
        {/* {props.required ? ( */}
        <CInputRadio
          custom
          id={`radio${props.value}`}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          checked={props.selectedOption === props.value}
          required={props.required} // Add required
        />
        {/* ) : (
          <CInputRadio
            custom
            id={`radio${props.value}`}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            checked={props.selectedOption === props.value}
          />
        )} */}

        <CLabel variant="custom-checkbox" htmlFor={`radio${props.value}`}>
          {props.label}
        </CLabel>
      </CFormGroup>
    </CCol>
  );
};

export const ControlInputValidationText = (props) => {
  if (props.name === "cgstAmount") console.log("invalid : ", props.invalid);
  return (
    <CCol className={props.className}>
      <>
        <CLabel htmlFor={props.id} className="col-form-label">
          {props.label} <span className="customRedFont">*</span> :
        </CLabel>
        {props.type === "date" ? (
          <CInput
            type={props.type}
            name={props.name}
            value={props.value}
            id={props.id}
            onChange={props.onChange}
            onBlur={props.onBlur}
            className={`mb-1 ${props.inputclassName || ""}`}
            invalid={props.isRequired && props.errorMessage ? true : false}
            min={props.min}
            max={props.max}
            aria-describedby={`${props.id}${props.name}`}
            disabled={props.disabled && props.disabled}
          />
        ) : (
          <CInput
            type={props.type}
            name={props.name}
            value={props.value}
            id={props.id}
            onChange={props.onChange}
            onBlur={props.onBlur}
            invalid={props.isRequired && props.errorMessage ? true : false}
            className={`mb-1 ${props.inputclassName || ""}`}
            min={props.min || undefined} // Ensure min is correctly passed
            max={props.max || undefined} // Ensure max is correctly passed
            aria-describedby={`${props.id}${props.name}`}
            disabled={props.disabled || undefined}
            step={props.step || "any"} // Use 'any' to allow non-stepped values
          />
        )}
        {props.isRequired && props.errorMessage && (
          <CFormText className="error-block">{props.errorMessage}</CFormText>
        )}
        {/* <CInvalidFeedback className={props.id}>
            {props.errorMessage}
          </CInvalidFeedback> */}
      </>
    </CCol>
  );
};

export const ControlTextAreaValidationText = (props) => {
  const rows = props.rows || 4;
  return (
    <>
      <CCol className={props.className}>
        <CLabel
          htmlFor={`validationCustom${props.id}`}
          className="col-form-label"
          style={{ width: "100%" }}
        >
          {props.label} <span className="customRedFont">*</span> :
        </CLabel>
        <CTextarea
          name={props.name}
          value={props.value}
          id={`validationCustom${props.id}`}
          onChange={props.onChange}
          className={`mb-1 ${props.inputclassName && props.inputclassName}`}
          min={props.min}
          max={props.max}
          invalid={props.isRequired && props.errorMessage ? true : false}
          aria-describedby={`validationCustom${props.id}_${props.name}`}
          rows={rows}
        />
        {props.isRequired && props.errorMessage && (
          <CFormText className="error-block">{props.errorMessage}</CFormText>
        )}
      </CCol>
    </>
  );
};

export const ControlInputValidation = (props) => {
  if (props.name === "cgstAmount") console.log("invalid : ", props.invalid);
  return (
    <CCol className={props.className}>
      {props.isRequired ? (
        <>
          <CLabel htmlFor={props.id} className="col-form-label">
            {props.label} <span className="customRedFont">*</span> :
          </CLabel>
          {props.type === "date" ? (
            <CInput
              //required
              type={props.type}
              name={props.name}
              value={props.value}
              id={props.id}
              onChange={props.onChange}
              onBlur={props.onBlur}
              className={`mb-1 ${props.inputclassName && props.inputclassName}`}
              min={props.min}
              max={props.max}
              invalid={props.invalid}
              aria-describedby={`${props.id}${props.name}`}
              disabled={props.disabled && props.disabled}
            />
          ) : (
            // <CInput
            //   required
            //   type={props.type}
            //   name={props.name}
            //   value={props.value}
            //   id={props.id}
            //   onChange={props.onChange}
            //   className={` mb-1 ${
            //     props.inputclassName && props.inputclassName
            //   }`}
            //   min={props.min}
            //   max={props.max}
            //   invalid={props.invalid}
            //   aria-describedby={`${props.id}${props.name}`}
            //   disabled={props.disabled && props.disabled}
            //   step={props.step}
            // />
            <CInput
              type={props.type}
              name={props.name}
              value={props.value}
              id={props.id}
              onChange={props.onChange}
              className={`mb-1 ${props.inputclassName || ""}`}
              min={props.min || undefined} // Ensure min is correctly passed
              max={props.max || undefined} // Ensure max is correctly passed
              invalid={props.invalid}
              aria-describedby={`${props.id}${props.name}`}
              disabled={props.disabled || undefined}
              step={props.step || "any"} // Use 'any' to allow non-stepped values
            />
          )}
          <CInvalidFeedback className={props.id}>
            {props.errorMessage}
          </CInvalidFeedback>
        </>
      ) : (
        <>
          <CLabel htmlFor={props.id} className="col-sm-12 col-form-label">
            {props.label}:
            <br />
          </CLabel>
          <CInput
            type={props.type}
            id={props.id}
            onChange={props.onChange}
            name={props.name}
            className={"mt-1 mb-1"}
            min={props.min}
            max={props.max}
            disabled={props.disabled && props.disabled}
          />
        </>
      )}
    </CCol>
  );
};

export const ControlInputValidationErrorArray = (props) => {
  if (props.name === "cgstAmount") console.log("invalid : ", props.invalid);
  return (
    <CCol className={props.className}>
      {props.isRequired ? (
        <>
          <CLabel htmlFor={props.id} className="col-form-label">
            {props.label} <span className="customRedFont">*</span> :
          </CLabel>
          <CInput
            required
            type={props.type}
            name={props.name}
            value={props.value}
            id={props.id}
            onChange={props.onChange}
            className={`mb-1 ${props.inputclassName || ""}`}
            min={props.min || undefined} // Ensure min is correctly passed
            max={props.max || undefined} // Ensure max is correctly passed
            invalid={props.invalid}
            aria-describedby={`${props.id}${props.name}`}
            disabled={props.disabled || undefined}
            step={props.step || "any"} // Use 'any' to allow non-stepped values
          />
          {props.invalid &&
            props.errorMessages &&
            props.errorMessages.length > 0 && (
              <div
                id={`${props.id}-error`}
                className={`invalid-feedback ${props.id}`}
              >
                {props.errorMessages.map((msg, index) => (
                  <CInvalidFeedback key={index}>{msg}</CInvalidFeedback>
                ))}
              </div>
            )}
          {/* <CInvalidFeedback className={props.id}>
            {props.errorMessage}
          </CInvalidFeedback> */}
        </>
      ) : (
        <>
          <CLabel htmlFor={props.id} className="col-sm-12 col-form-label">
            {props.label}:
            <br />
          </CLabel>
          <CInput
            type={props.type}
            id={props.id}
            onChange={props.onChange}
            name={props.name}
            className={"mt-1 mb-1"}
            min={props.min}
            max={props.max}
            disabled={props.disabled && props.disabled}
          />
        </>
      )}
    </CCol>
  );
};

export const ControlTextAreaValidation = (props) => {
  const rows = props.rows || 4;
  return (
    <>
      <CCol className={props.className}>
        {props.isRequired ? (
          <>
            <CLabel
              htmlFor={`validationCustom${props.id}`}
              className="col-form-label"
              style={{ width: "100%" }}
            >
              {props.label} <span className="customRedFont">*</span> :
            </CLabel>
            <CTextarea
              required
              name={props.name}
              value={props.value}
              id={`validationCustom${props.id}`}
              onChange={props.onChange}
              className={`mb-1 ${props.inputclassName && props.inputclassName}`}
              min={props.min}
              max={props.max}
              invalid={props.invalid}
              aria-describedby={`validationCustom${props.id}_${props.name}`}
              rows={rows}
            />
            <CInvalidFeedback className={`validationCustom${props.id}`}>
              {props.errorMessage}
            </CInvalidFeedback>
          </>
        ) : (
          <>
            <CLabel htmlFor={props.id} className="col-form-label">
              {props.label} <span className="customRedFont">*</span> :
            </CLabel>
            <br />
            <CTextarea
              name={props.name}
              value={props.value}
              id={props.id}
              onChange={props.onChange}
              className={`mb-1 ${props.inputclassName && props.inputclassName}`}
              min={props.min}
              max={props.max}
              rows={rows}
              placeholder="Content..."
            />
          </>
        )}
      </CCol>
    </>
  );
};

export const ControlSelectValidation = (props) => {
  return (
    <CCol className={props.className}>
      <>
        <CLabel htmlFor={props.id} className="col-form-label">
          {props.label}{" "}
          {props.isRequired && <span className="customRedFont">*</span>} :
        </CLabel>
        <CSelect
          required
          aria-label="Default select example"
          id={props.id === "" ? props.name : props.id}
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          //invalid={props.isRequired && props.errorMessage ? true : false}
          //  aria-describedby={`validationCustom${props.id}_${props.name}`}
        >
          {props.isSelectShow !== false && (
            <option value="">Select {props.label}</option>
          )}
          {props.items?.map((item, key) => (
            <option key={key} value={item.value}>
              {item.label}
            </option>
          ))}
        </CSelect>
        {props.isRequired && props.errorMessage && (
          <CFormText className="error-block">{props.errorMessage}</CFormText>
        )}
        {/* <CInvalidFeedback className={props.id}>
            {props.errorMessage}
          </CInvalidFeedback> */}
      </>
    </CCol>
  );
};

export const ControlFileUpload = (props) => {
  const acceptFile = props.acceptFile || ".pdf";
  const className = props.className || "col-sm-12";
  let displayUploadController = props.displayUploadController;
  if (displayUploadController === "") {
    displayUploadController = true;
  }
  return (
    <>
      <CCol className={className}>
        {props.isRequired ? (
          <>
            <CLabel htmlFor={props.id} className=" col-form-label">
              {props.label} <span className="customRedFont">*</span> :
              <br />
            </CLabel>
            {displayUploadController && (
              <>
                <CInputGroup className="mb-1">
                  <div className="custom-file">
                    <input
                      invalid={
                        props.isRequired && props.errorMessage ? true : false
                      }
                      required
                      id={`inputGroupFile${props.id}`}
                      type="file"
                      accept={acceptFile}
                      className="custom-file-input"
                      onChange={props.onChange}
                      style={{ marginTop: "0px !important" }}
                    />
                    <label
                      className="custom-file-label"
                      htmlFor={`inputGroupFile${props.id}`}
                    >
                      {props.selectedFile
                        ? props.selectedFile.name
                        : "Choose file"}
                    </label>
                  </div>
                </CInputGroup>
                {props.errorMessage && (
                  <CFormText className="error-block">
                    {props.errorMessage}
                  </CFormText>
                )}
              </>
            )}

            {/* <CInputGroup className="mb-3">
              <div className="custom-file">
                <CInputFile
                  innerRef={props.fileInputRef}
                  //ref={props.fileInputRef}
                  required
                  type="file"
                  //  id="inputGroupFile01"
                  style={{ display: "inline" }}
                  name={props.name}
                  id={`validationCustom${props.id}`}
                  accept={acceptFile}
                  onChange={props.onChange}
                  //value={props.selectedFile.name}
                />
              </div>
              {props.selectedFile && (
                <p style={{ marginTop: "10px" }}>
                  <strong>Selected File:</strong> {props.selectedFile.name}
                </p>
              )}
            </CInputGroup> */}
            {/* <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  required
                  type="file"
                  style={{ display: "inline", marginLeft: "20px" }}
                  name={props.name}
                  id={`validationCustom${props.id}`}
                  accept={acceptFile}
                  onChange={props.onChange}
                  // onChange={(e) => {
                  //   setApprovalDocumentFileEvent(e);
                  //   setApprovalDocumentSelectedFile(e.target.files[0]);
                  //   e.preventDefault();
                  // }}
                />
                <label
                  className="custom-file-label "
                  htmlFor={`inputGroupFile${props.id}`}
                >
                  {props.selectedFile ? (
                    props.selectedFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div> 
              {props.errorMessage && (
                <CFormText className="error-block">
                  {props.errorMessage}
                </CFormText>
              )}
            </CInputGroup>*/}
            {/* <CInvalidFeedback className={`validationCustom${props.id}`}>
              {props.errorMessage}
            </CInvalidFeedback> */}
          </>
        ) : (
          <>
            <CLabel htmlFor={props.id} className=" col-form-label">
              {props.label} :
            </CLabel>
            <CInputGroup className="mb-3">
              <div className="custom-file">
                <input
                  id={`inputGroupFile${props.id}`}
                  type="file"
                  accept={acceptFile}
                  className="custom-file-input"
                  onChange={props.onChange}
                />
                <label
                  className="custom-file-label "
                  htmlFor={`inputGroupFile${props.id}`}
                >
                  {props.selectedFile ? (
                    props.selectedFile.name
                  ) : (
                    <>Choose file</>
                  )}
                </label>
              </div>
              {props.errorMessage && (
                <CFormText className="error-block">
                  {props.errorMessage}
                </CFormText>
              )}
            </CInputGroup>
          </>
        )}
      </CCol>
    </>
  );
};

export const CommanPageLoader = (props) => {
  return (
    <CRow>
      <CCol xs="12">
        <CCardHeader>
          <h2>{props.title}</h2>
        </CCardHeader>
        <CCardBody>
          <CSpinner
            className="spinner-grow col-6 offset-6 mt-6"
            color="success"
          />
        </CCardBody>
      </CCol>
    </CRow>
  );
};

//{viewUserDocuments !== undefined && viewUserDocuments !== null &&

export const AnchorLinkSetOnClick = (props) => {
  const setButtonName = props.ButtonName || "View";
  return (
    <a
      className={`ml-2 ${props.className}`}
      rel="noreferrer"
      onClick={props.onClick}
    >
      <b>{setButtonName}</b>
    </a>
  );
};
export const AnchorLinkSet = (props) => {
  const fileName =
    props.fileName !== undefined &&
    props.fileName !== "" &&
    props.fileName !== null;
  const setButtonName = props.ButtonName || "View";
  return fileName ? (
    <a
      className={`ml-2 ${props.className}`}
      target="_blank"
      href={`${downloadUrl}/${props.filepath}/${props.fileName}`}
      rel="noreferrer"
    >
      <b>{setButtonName}</b>
    </a>
  ) : (
    ""
  );
};
export const ViewDocumentButton = (props) => {
  const fileName =
    props.fileName !== undefined &&
    props.fileName !== "" &&
    props.fileName !== null;

  const setButtonName = props.ButtonName || "View";
  const setClassName =
    props.className || "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12 mt-2";
  return (
    <CCol className={setClassName}>
      <CLabel> {props.label} : </CLabel>
      <br />
      {fileName ? (
        <a
          className="ml-2"
          target="_blank"
          href={`${downloadUrl}/${props.filepath}/${props.fileName}`}
          rel="noreferrer"
        >
          <b>{setButtonName}</b>
        </a>
      ) : (
        ""
      )}
    </CCol>
  );
};

export const CommonBtnTo = (props) => {
  const color =
    props.color === null || props.color === undefined ? "success" : props.color;
  const isDisplayAllow =
    props.isDisplayAllow === null || props.isDisplayAllow === undefined
      ? true
      : props.isDisplayAllow;
  return (
    isDisplayAllow === true && (
      <CButton
        className={props.className}
        variant="outline"
        shape="square"
        size="sm"
        to={props.to}
        color={color}
      >
        {props.ButtonName}
      </CButton>
    )
  );
};

export const CommonBtn = (props) => {
  const color =
    props.color === null || props.color === undefined ? "success" : props.color;
  const isDisplayAllow =
    props.isDisplayAllow === null || props.isDisplayAllow === undefined
      ? true
      : props.isDisplayAllow;
  return (
    isDisplayAllow === true && (
      <CButton
        className={`mt-1  ${props.className}`}
        variant="outline"
        shape="square"
        size="sm"
        disabled={props.disabled}
        color={color}
        onClick={props.onClick}
      >
        {props.buttonName}
      </CButton>
    )
  );
};
export const requiredValid = (isValid, msg = "") => {
  const REQUIRED = "'This feild is Required!'";
  return isValid
    ? { isValid: true, Message: "" }
    : { isValid: false, Message: msg === "" ? REQUIRED : msg };
  // val !== undefined && val.length > 0
  //   ? { isValid: true, Message: "" }
  //   : { isValid: false, Message: msg === "" ? REQUIRED : msg };
};
